export const PRODUCTS = {
  EXPRESS_PRAT: 4,
  PREMIUM_PRAT: 2,
  URBAN_PARKING: 13,
  PREMIUM_BARAJAS: 12,
  SANTS: 5,
  PUERTO: 3,
  ATOCHA: 6,
};
